<div class="actions">
  <button mat-raised-button [matMenuTriggerFor]="appMenu"
          style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
          class="button">
    Actions<span class="mat-select-arrow"
                 style="display:inline-block; width: 0;height: 0;border-left: 5px solid transparent;border-right: 5px solid transparent;border-top: 5px solid;margin: 0 4px;"></span>
  </button>
  <mat-menu #appMenu="matMenu">
    <button mat-menu-item
            type="button"
            (click)="createList()"
    >
      Add List
    </button>
    <button mat-menu-item
            type="button"
            (click)="importReferenceResources()"
    >
      Import Reference Resource Data
    </button>
    <button mat-menu-item
            type="button"
            (click)="table.exportCSV()"
    >
      Export CSV
    </button>
  </mat-menu>
</div>

<p-table [columns]="exportCols"
         [value]="items"
         [style]="{'margin-top':'10px'}"
         dataKey="listId"
         #table>

  <ng-template pTemplate="header">
    <tr style="white-space: nowrap;font-weight: bold">
      <th *ngFor="let col of cols">{{col.header}}</th>
      <th style="width:8em"></th>
    </tr>
    <tr>
      <th *ngFor="let col of cols">
        <input pInputText type="text" placeholder="⌕" (input)="table.filter($event.target['value'], col.field, 'contains')" />
      </th>
      <th></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded">
    <tr class="ui-widget-header"
        *ngIf="rowGroupIndexes[item.listId] === rowIndex">
      <td [attr.colspan]="cols.length">
        <a href="#" [pRowToggler]="item">
          <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
          <span>{{item.listName }}</span>
        </a>
      </td>
      <td>
        <button
          type="button"
          pButton
          class="risksponge-button"
          (click)="editList(item)"
          icon="pi pi-pencil">
        </button>
        <button
          type="button"
          pButton
          class="risksponge-button"
          (click)="deleteList(item.listId)"
          icon="pi pi-times">
        </button>
        <button
          type="button"
          pButton
          class="risksponge-button"
          (click)="createItem(item.listId)"
          icon="pi pi-plus">
        </button>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="expandedrow" let-item>
    <tr *ngIf="!item.virtual">
      <td *ngFor="let col of cols" [innerHTML]="col.fn && item[col.field] ? col.fn(item[col.field]) : item[col.field]"></td>
      <td style="width: 5em;">
        <button
          type="button"
          pButton
          class="risksponge-button"
          (click)="editItem(item)"
          icon="pi pi-pencil">
        </button>
        <button
          type="button"
          pButton
          class="risksponge-button"
          (click)="deleteItem(item.referenceResourceId)"
          icon="pi pi-times">
        </button>
      </td>
    </tr>
    <tr *ngIf="item.virtual">
      <td [attr.colspan]="cols.length + 1">No items</td>
    </tr>
  </ng-template>

</p-table>
